import React from 'react';
import {AnswersList, NeuroMessage} from "@ignitesales/neuro-application";
import classnames from "classnames";
import Collapsible from "react-collapsible";

const CollapsibleAnswersList = ({ className, shouldLinkToQuestion }) => {
    const componentClass = "collapsibleAnswersList";
    const classes = classnames(componentClass, className);

    return <div className={classes}>
        <Collapsible trigger={<div className='answersListHeader'><NeuroMessage id='summary.viewAnswers' /></div>}>
            <AnswersList linkToQuestion={shouldLinkToQuestion} />
        </Collapsible>
    </div>
};

export default CollapsibleAnswersList;
